module.exports = __webpack_public_path__ + "49781b685779cabc59c4fc1c8acd1cd2.png";